import useFeatureFlags from "./use-feature-flags";

interface UseWebOriEnabledReturn {
  enabled: boolean;
  loading: boolean;
}

// Web Ori is gated by the per-company entitlement (`ori`, shared with mobile).
export default function useWebOriEnabled(): UseWebOriEnabledReturn {
  const { isEnabled, loading } = useFeatureFlags();

  return {
    enabled: isEnabled("ori"),
    loading,
  };
}
